import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelected } from "../redux/eventLogsSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const ActionsFilterDropdown = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.eventLogs.options.actions);
  const selectedFilters = useSelector((state) => state.eventLogs.selected.action);

  const onActionChange = (selected) => {
    dispatch(setSelected({ action: selected }));
  };

  return (
    <div>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedFilters}
        placeholder="Select Action"
        includeFilter={false}
        numberDisplayed={0}
        onSelectChange={(data) => onActionChange(data)}
      />
    </div>
  );
};

export default ActionsFilterDropdown;
